<template>
  <div id="invitation">
    <van-row>
      <van-col span="24" class="invite_rewards_superior_bg">
        <van-col span="22" offset="1" class="invite_rewards_superior">
          <van-col span="24" class="invite_rewards_superior_img">
            <img :src="user.head_image"/>
          </van-col>
          <van-col span="24" class="invite_rewards_superior_name">{{ user.nick_name }}</van-col>
          <van-col span="24" class="invite_rewards_superior_id">{{ user.id }}</van-col>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  export default {
    data() {
      return {
        user: {}
      }
    },
    created: function() {
      this.convert()
      document.title = this.$t('title.my_superior')
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=superior", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.user = res.data.data
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invitation_superior.vue